/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PublicRouteRouteImport } from './routes/public/route'
import { Route as AppChatRouteRouteImport } from './routes/_app/_chat/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as OfficeAuthCallbackRouteImport } from './routes/office/auth-callback'
import { Route as OfficeTaskpaneRouteImport } from './routes/office/taskpane'
import { Route as AppForgotPasswordIndexRouteImport } from './routes/_app/forgot-password/index'
import { Route as AppLoginIndexRouteImport } from './routes/_app/login/index'
import { Route as AppResetPasswordIndexRouteImport } from './routes/_app/reset-password/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSignupIndexRouteImport } from './routes/_app/signup/index'
import { Route as PublicChatSlugRouteImport } from './routes/public/chat/$slug'
import { Route as PublicShareTokenRouteImport } from './routes/public/share/$token'
import { Route as PublicWidgetSlugRouteImport } from './routes/public/widget/$slug'
import { Route as AppChatAgentsIndexRouteImport } from './routes/_app/_chat/agents/index'
import { Route as AppChatAgentsIdRouteRouteImport } from './routes/_app/_chat/agents/$id/route'
import { Route as AppChatAppsIndexRouteImport } from './routes/_app/_chat/apps/index'
import { Route as AppChatAppsIdRouteRouteImport } from './routes/_app/_chat/apps/$id/route'
import { Route as AppChatChatIndexRouteImport } from './routes/_app/_chat/chat/index'
import { Route as AppChatChatIdRouteImport } from './routes/_app/_chat/chat/$id'
import { Route as AppChatChatNewRouteImport } from './routes/_app/_chat/chat/new'
import { Route as AppChatProjectsIndexRouteImport } from './routes/_app/_chat/projects/index'
import { Route as AppChatProjectsProjectIdRouteRouteImport } from './routes/_app/_chat/projects/$projectId/route'
import { Route as AppChatSkillsIndexRouteImport } from './routes/_app/_chat/skills/index'
import { Route as AppChatSkillsIdRouteRouteImport } from './routes/_app/_chat/skills/$id/route'
import { Route as AppChatStagingInboxIndexRouteImport } from './routes/_app/_chat/staging-inbox/index'
import { Route as AppEmailChangeConfirmIndexRouteImport } from './routes/_app/email-change/confirm/index'
import { Route as AppInviteAcceptIndexRouteImport } from './routes/_app/invite/accept/index'
import { Route as AppOauthCallbackIndexRouteImport } from './routes/_app/oauth/callback/index'
import { Route as AppOauthMcpConsentIndexRouteImport } from './routes/_app/oauth/mcp-consent/index'
import { Route as AppSettingsAnalyticsIndexRouteImport } from './routes/_app/settings/analytics/index'
import { Route as AppSettingsBillingIndexRouteImport } from './routes/_app/settings/billing/index'
import { Route as AppSettingsConnectionsIndexRouteImport } from './routes/_app/settings/connections/index'
import { Route as AppSettingsCredentialsIndexRouteImport } from './routes/_app/settings/credentials/index'
import { Route as AppSettingsDataSourcesIndexRouteImport } from './routes/_app/settings/data-sources/index'
import { Route as AppSettingsErrorLogIndexRouteImport } from './routes/_app/settings/error-log/index'
import { Route as AppSettingsFeatureFlagsIndexRouteImport } from './routes/_app/settings/feature-flags/index'
import { Route as AppSettingsGroupsIndexRouteImport } from './routes/_app/settings/groups/index'
import { Route as AppSettingsKnowledgeIndexRouteImport } from './routes/_app/settings/knowledge/index'
import { Route as AppSettingsModelsIndexRouteImport } from './routes/_app/settings/models/index'
import { Route as AppSettingsOnPremiseIndexRouteImport } from './routes/_app/settings/on-premise/index'
import { Route as AppSettingsPartnerIndexRouteImport } from './routes/_app/settings/partner/index'
import { Route as AppSettingsPersonalIndexRouteImport } from './routes/_app/settings/personal/index'
import { Route as AppSettingsSecurityIndexRouteImport } from './routes/_app/settings/security/index'
import { Route as AppSettingsToolsIndexRouteImport } from './routes/_app/settings/tools/index'
import { Route as AppSettingsTrainingRecordsIndexRouteImport } from './routes/_app/settings/training-records/index'
import { Route as AppSettingsTrainingIndexRouteImport } from './routes/_app/settings/training/index'
import { Route as AppSettingsUsersIndexRouteImport } from './routes/_app/settings/users/index'
import { Route as AppSettingsWorkspaceErrorLogIndexRouteImport } from './routes/_app/settings/workspace-error-log/index'
import { Route as AppSettingsWorkspaceIndexRouteImport } from './routes/_app/settings/workspace/index'
import { Route as AppSettingsWorkspacesIndexRouteImport } from './routes/_app/settings/workspaces/index'
import { Route as AppSignupCompleteIndexRouteImport } from './routes/_app/signup/complete/index'
import { Route as AppChatAgentsIdIndexRouteImport } from './routes/_app/_chat/agents/$id/index'
import { Route as AppChatAppsIdIndexRouteImport } from './routes/_app/_chat/apps/$id/index'
import { Route as AppChatAppsIdAccessRouteImport } from './routes/_app/_chat/apps/$id/access'
import { Route as AppChatAppsIdOpenRouteImport } from './routes/_app/_chat/apps/$id_.open'
import { Route as AppChatProjectsProjectIdIndexRouteImport } from './routes/_app/_chat/projects/$projectId/index'
import { Route as AppChatProjectsNewIndexRouteImport } from './routes/_app/_chat/projects/new/index'
import { Route as AppChatSkillsIdIndexRouteImport } from './routes/_app/_chat/skills/$id/index'
import { Route as AppChatSkillsNewIndexRouteImport } from './routes/_app/_chat/skills/new/index'
import { Route as AppSettingsBillingCheckoutIndexRouteImport } from './routes/_app/settings/billing/checkout/index'
import { Route as AppSettingsDataSourcesIdIndexRouteImport } from './routes/_app/settings/data-sources/$id/index'
import { Route as AppSettingsGroupsIdIndexRouteImport } from './routes/_app/settings/groups/$id/index'
import { Route as AppSettingsKnowledgeIdIndexRouteImport } from './routes/_app/settings/knowledge/$id/index'
import { Route as AppSettingsOnPremiseIdIndexRouteImport } from './routes/_app/settings/on-premise/$id/index'
import { Route as AppSettingsToolsIdIndexRouteImport } from './routes/_app/settings/tools/$id/index'
import { Route as AppSettingsToolsNewIndexRouteImport } from './routes/_app/settings/tools/new/index'
import { Route as AppSettingsToolsTemplatesIndexRouteImport } from './routes/_app/settings/tools/templates/index'
import { Route as AppChatAgentsIdDangerIndexRouteImport } from './routes/_app/_chat/agents/$id/danger/index'
import { Route as AppChatAgentsIdFilesIndexRouteImport } from './routes/_app/_chat/agents/$id/files/index'
import { Route as AppChatAgentsIdGeneralIndexRouteImport } from './routes/_app/_chat/agents/$id/general/index'
import { Route as AppChatAgentsIdHistoryIndexRouteImport } from './routes/_app/_chat/agents/$id/history/index'
import { Route as AppChatAgentsIdIntegrationsIndexRouteImport } from './routes/_app/_chat/agents/$id/integrations/index'
import { Route as AppChatAgentsIdModelsAndCostsIndexRouteImport } from './routes/_app/_chat/agents/$id/models-and-costs/index'
import { Route as AppChatAgentsIdPromptIndexRouteImport } from './routes/_app/_chat/agents/$id/prompt/index'
import { Route as AppChatAgentsIdSharingIndexRouteImport } from './routes/_app/_chat/agents/$id/sharing/index'
import { Route as AppChatAgentsIdTriggerIndexRouteImport } from './routes/_app/_chat/agents/$id/trigger/index'
import { Route as AppChatAppsIdGeneralIndexRouteImport } from './routes/_app/_chat/apps/$id/general/index'
import { Route as AppChatAppsIdToolsIndexRouteImport } from './routes/_app/_chat/apps/$id/tools/index'
import { Route as AppChatAppsIdVersionsIndexRouteImport } from './routes/_app/_chat/apps/$id/versions/index'
import { Route as AppChatProjectsProjectIdSettingsIndexRouteImport } from './routes/_app/_chat/projects/$projectId/settings/index'
import { Route as AppChatProjectsNewChatIdIndexRouteImport } from './routes/_app/_chat/projects/new/$chatId/index'
import { Route as AppChatSkillsIdConnectionsIndexRouteImport } from './routes/_app/_chat/skills/$id/connections/index'
import { Route as AppChatSkillsIdDangerIndexRouteImport } from './routes/_app/_chat/skills/$id/danger/index'
import { Route as AppChatSkillsIdDefinitionIndexRouteImport } from './routes/_app/_chat/skills/$id/definition/index'
import { Route as AppChatSkillsIdFilesIndexRouteImport } from './routes/_app/_chat/skills/$id/files/index'
import { Route as AppChatSkillsIdGeneralIndexRouteImport } from './routes/_app/_chat/skills/$id/general/index'
import { Route as AppChatSkillsIdSharingIndexRouteImport } from './routes/_app/_chat/skills/$id/sharing/index'
import { Route as AppChatSkillsEditChatIdIndexRouteImport } from './routes/_app/_chat/skills/edit/$chatId/index'
import { Route as AppChatSkillsNewChatIdIndexRouteImport } from './routes/_app/_chat/skills/new/$chatId/index'
import { Route as AppSettingsPersonalImportsChatgptIndexRouteImport } from './routes/_app/settings/personal/imports/chatgpt/index'
import { Route as AppChatAgentsIdChatChatIdIndexRouteImport } from './routes/_app/_chat/agents/$id/chat/$chatId/index'
import { Route as AppChatAgentsIdRunsRunIdIndexRouteImport } from './routes/_app/_chat/agents/$id/runs/$runId/index'
import { Route as AppChatProjectsProjectIdChatChatIdIndexRouteImport } from './routes/_app/_chat/projects/$projectId/chat/$chatId/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppChatRouteRoute = AppChatRouteRouteImport.update({
  id: '/_chat',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const OfficeAuthCallbackRoute = OfficeAuthCallbackRouteImport.update({
  id: '/office/auth-callback',
  path: '/office/auth-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OfficeTaskpaneRoute = OfficeTaskpaneRouteImport.update({
  id: '/office/taskpane',
  path: '/office/taskpane',
  getParentRoute: () => rootRouteImport,
} as any)
const AppForgotPasswordIndexRoute = AppForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => AppRoute,
} as any)
const AppLoginIndexRoute = AppLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AppRoute,
} as any)
const AppResetPasswordIndexRoute = AppResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSignupIndexRoute = AppSignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => AppRoute,
} as any)
const PublicChatSlugRoute = PublicChatSlugRouteImport.update({
  id: '/chat/$slug',
  path: '/chat/$slug',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicShareTokenRoute = PublicShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicWidgetSlugRoute = PublicWidgetSlugRouteImport.update({
  id: '/widget/$slug',
  path: '/widget/$slug',
  getParentRoute: () => PublicRouteRoute,
} as any)
const AppChatAgentsIndexRoute = AppChatAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatAgentsIdRouteRoute = AppChatAgentsIdRouteRouteImport.update({
  id: '/agents/$id',
  path: '/agents/$id',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatAppsIndexRoute = AppChatAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatAppsIdRouteRoute = AppChatAppsIdRouteRouteImport.update({
  id: '/apps/$id',
  path: '/apps/$id',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatChatIndexRoute = AppChatChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatChatIdRoute = AppChatChatIdRouteImport.update({
  id: '/chat/$id',
  path: '/chat/$id',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatChatNewRoute = AppChatChatNewRouteImport.update({
  id: '/chat/new',
  path: '/chat/new',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatProjectsIndexRoute = AppChatProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatProjectsProjectIdRouteRoute =
  AppChatProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AppChatRouteRoute,
  } as any)
const AppChatSkillsIndexRoute = AppChatSkillsIndexRouteImport.update({
  id: '/skills/',
  path: '/skills/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatSkillsIdRouteRoute = AppChatSkillsIdRouteRouteImport.update({
  id: '/skills/$id',
  path: '/skills/$id',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatStagingInboxIndexRoute =
  AppChatStagingInboxIndexRouteImport.update({
    id: '/staging-inbox/',
    path: '/staging-inbox/',
    getParentRoute: () => AppChatRouteRoute,
  } as any)
const AppEmailChangeConfirmIndexRoute =
  AppEmailChangeConfirmIndexRouteImport.update({
    id: '/email-change/confirm/',
    path: '/email-change/confirm/',
    getParentRoute: () => AppRoute,
  } as any)
const AppInviteAcceptIndexRoute = AppInviteAcceptIndexRouteImport.update({
  id: '/invite/accept/',
  path: '/invite/accept/',
  getParentRoute: () => AppRoute,
} as any)
const AppOauthCallbackIndexRoute = AppOauthCallbackIndexRouteImport.update({
  id: '/oauth/callback/',
  path: '/oauth/callback/',
  getParentRoute: () => AppRoute,
} as any)
const AppOauthMcpConsentIndexRoute = AppOauthMcpConsentIndexRouteImport.update({
  id: '/oauth/mcp-consent/',
  path: '/oauth/mcp-consent/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAnalyticsIndexRoute =
  AppSettingsAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsBillingIndexRoute = AppSettingsBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsConnectionsIndexRoute =
  AppSettingsConnectionsIndexRouteImport.update({
    id: '/connections/',
    path: '/connections/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCredentialsIndexRoute =
  AppSettingsCredentialsIndexRouteImport.update({
    id: '/credentials/',
    path: '/credentials/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsDataSourcesIndexRoute =
  AppSettingsDataSourcesIndexRouteImport.update({
    id: '/data-sources/',
    path: '/data-sources/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsErrorLogIndexRoute =
  AppSettingsErrorLogIndexRouteImport.update({
    id: '/error-log/',
    path: '/error-log/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsFeatureFlagsIndexRoute =
  AppSettingsFeatureFlagsIndexRouteImport.update({
    id: '/feature-flags/',
    path: '/feature-flags/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsGroupsIndexRoute = AppSettingsGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsKnowledgeIndexRoute =
  AppSettingsKnowledgeIndexRouteImport.update({
    id: '/knowledge/',
    path: '/knowledge/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsModelsIndexRoute = AppSettingsModelsIndexRouteImport.update({
  id: '/models/',
  path: '/models/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOnPremiseIndexRoute =
  AppSettingsOnPremiseIndexRouteImport.update({
    id: '/on-premise/',
    path: '/on-premise/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsPartnerIndexRoute = AppSettingsPartnerIndexRouteImport.update({
  id: '/partner/',
  path: '/partner/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPersonalIndexRoute =
  AppSettingsPersonalIndexRouteImport.update({
    id: '/personal/',
    path: '/personal/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsSecurityIndexRoute =
  AppSettingsSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsToolsIndexRoute = AppSettingsToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTrainingRecordsIndexRoute =
  AppSettingsTrainingRecordsIndexRouteImport.update({
    id: '/training-records/',
    path: '/training-records/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsTrainingIndexRoute =
  AppSettingsTrainingIndexRouteImport.update({
    id: '/training/',
    path: '/training/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsUsersIndexRoute = AppSettingsUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsWorkspaceErrorLogIndexRoute =
  AppSettingsWorkspaceErrorLogIndexRouteImport.update({
    id: '/workspace-error-log/',
    path: '/workspace-error-log/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsWorkspaceIndexRoute =
  AppSettingsWorkspaceIndexRouteImport.update({
    id: '/workspace/',
    path: '/workspace/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsWorkspacesIndexRoute =
  AppSettingsWorkspacesIndexRouteImport.update({
    id: '/workspaces/',
    path: '/workspaces/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSignupCompleteIndexRoute = AppSignupCompleteIndexRouteImport.update({
  id: '/signup/complete/',
  path: '/signup/complete/',
  getParentRoute: () => AppRoute,
} as any)
const AppChatAgentsIdIndexRoute = AppChatAgentsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChatAgentsIdRouteRoute,
} as any)
const AppChatAppsIdIndexRoute = AppChatAppsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChatAppsIdRouteRoute,
} as any)
const AppChatAppsIdAccessRoute = AppChatAppsIdAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AppChatAppsIdRouteRoute,
} as any)
const AppChatAppsIdOpenRoute = AppChatAppsIdOpenRouteImport.update({
  id: '/apps/$id_/open',
  path: '/apps/$id/open',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatProjectsProjectIdIndexRoute =
  AppChatProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppChatProjectsProjectIdRouteRoute,
  } as any)
const AppChatProjectsNewIndexRoute = AppChatProjectsNewIndexRouteImport.update({
  id: '/projects/new/',
  path: '/projects/new/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppChatSkillsIdIndexRoute = AppChatSkillsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChatSkillsIdRouteRoute,
} as any)
const AppChatSkillsNewIndexRoute = AppChatSkillsNewIndexRouteImport.update({
  id: '/skills/new/',
  path: '/skills/new/',
  getParentRoute: () => AppChatRouteRoute,
} as any)
const AppSettingsBillingCheckoutIndexRoute =
  AppSettingsBillingCheckoutIndexRouteImport.update({
    id: '/billing/checkout/',
    path: '/billing/checkout/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsDataSourcesIdIndexRoute =
  AppSettingsDataSourcesIdIndexRouteImport.update({
    id: '/data-sources/$id/',
    path: '/data-sources/$id/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsGroupsIdIndexRoute =
  AppSettingsGroupsIdIndexRouteImport.update({
    id: '/groups/$id/',
    path: '/groups/$id/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsKnowledgeIdIndexRoute =
  AppSettingsKnowledgeIdIndexRouteImport.update({
    id: '/knowledge/$id/',
    path: '/knowledge/$id/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsOnPremiseIdIndexRoute =
  AppSettingsOnPremiseIdIndexRouteImport.update({
    id: '/on-premise/$id/',
    path: '/on-premise/$id/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsToolsIdIndexRoute = AppSettingsToolsIdIndexRouteImport.update({
  id: '/tools/$id/',
  path: '/tools/$id/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsToolsNewIndexRoute =
  AppSettingsToolsNewIndexRouteImport.update({
    id: '/tools/new/',
    path: '/tools/new/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsToolsTemplatesIndexRoute =
  AppSettingsToolsTemplatesIndexRouteImport.update({
    id: '/tools/templates/',
    path: '/tools/templates/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppChatAgentsIdDangerIndexRoute =
  AppChatAgentsIdDangerIndexRouteImport.update({
    id: '/danger/',
    path: '/danger/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAgentsIdFilesIndexRoute =
  AppChatAgentsIdFilesIndexRouteImport.update({
    id: '/files/',
    path: '/files/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAgentsIdGeneralIndexRoute =
  AppChatAgentsIdGeneralIndexRouteImport.update({
    id: '/general/',
    path: '/general/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAgentsIdHistoryIndexRoute =
  AppChatAgentsIdHistoryIndexRouteImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAgentsIdIntegrationsIndexRoute =
  AppChatAgentsIdIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAgentsIdModelsAndCostsIndexRoute =
  AppChatAgentsIdModelsAndCostsIndexRouteImport.update({
    id: '/models-and-costs/',
    path: '/models-and-costs/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAgentsIdPromptIndexRoute =
  AppChatAgentsIdPromptIndexRouteImport.update({
    id: '/prompt/',
    path: '/prompt/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAgentsIdSharingIndexRoute =
  AppChatAgentsIdSharingIndexRouteImport.update({
    id: '/sharing/',
    path: '/sharing/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAgentsIdTriggerIndexRoute =
  AppChatAgentsIdTriggerIndexRouteImport.update({
    id: '/trigger/',
    path: '/trigger/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAppsIdGeneralIndexRoute =
  AppChatAppsIdGeneralIndexRouteImport.update({
    id: '/general/',
    path: '/general/',
    getParentRoute: () => AppChatAppsIdRouteRoute,
  } as any)
const AppChatAppsIdToolsIndexRoute = AppChatAppsIdToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => AppChatAppsIdRouteRoute,
} as any)
const AppChatAppsIdVersionsIndexRoute =
  AppChatAppsIdVersionsIndexRouteImport.update({
    id: '/versions/',
    path: '/versions/',
    getParentRoute: () => AppChatAppsIdRouteRoute,
  } as any)
const AppChatProjectsProjectIdSettingsIndexRoute =
  AppChatProjectsProjectIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AppChatProjectsProjectIdRouteRoute,
  } as any)
const AppChatProjectsNewChatIdIndexRoute =
  AppChatProjectsNewChatIdIndexRouteImport.update({
    id: '/projects/new/$chatId/',
    path: '/projects/new/$chatId/',
    getParentRoute: () => AppChatRouteRoute,
  } as any)
const AppChatSkillsIdConnectionsIndexRoute =
  AppChatSkillsIdConnectionsIndexRouteImport.update({
    id: '/connections/',
    path: '/connections/',
    getParentRoute: () => AppChatSkillsIdRouteRoute,
  } as any)
const AppChatSkillsIdDangerIndexRoute =
  AppChatSkillsIdDangerIndexRouteImport.update({
    id: '/danger/',
    path: '/danger/',
    getParentRoute: () => AppChatSkillsIdRouteRoute,
  } as any)
const AppChatSkillsIdDefinitionIndexRoute =
  AppChatSkillsIdDefinitionIndexRouteImport.update({
    id: '/definition/',
    path: '/definition/',
    getParentRoute: () => AppChatSkillsIdRouteRoute,
  } as any)
const AppChatSkillsIdFilesIndexRoute =
  AppChatSkillsIdFilesIndexRouteImport.update({
    id: '/files/',
    path: '/files/',
    getParentRoute: () => AppChatSkillsIdRouteRoute,
  } as any)
const AppChatSkillsIdGeneralIndexRoute =
  AppChatSkillsIdGeneralIndexRouteImport.update({
    id: '/general/',
    path: '/general/',
    getParentRoute: () => AppChatSkillsIdRouteRoute,
  } as any)
const AppChatSkillsIdSharingIndexRoute =
  AppChatSkillsIdSharingIndexRouteImport.update({
    id: '/sharing/',
    path: '/sharing/',
    getParentRoute: () => AppChatSkillsIdRouteRoute,
  } as any)
const AppChatSkillsEditChatIdIndexRoute =
  AppChatSkillsEditChatIdIndexRouteImport.update({
    id: '/skills/edit/$chatId/',
    path: '/skills/edit/$chatId/',
    getParentRoute: () => AppChatRouteRoute,
  } as any)
const AppChatSkillsNewChatIdIndexRoute =
  AppChatSkillsNewChatIdIndexRouteImport.update({
    id: '/skills/new/$chatId/',
    path: '/skills/new/$chatId/',
    getParentRoute: () => AppChatRouteRoute,
  } as any)
const AppSettingsPersonalImportsChatgptIndexRoute =
  AppSettingsPersonalImportsChatgptIndexRouteImport.update({
    id: '/personal/imports/chatgpt/',
    path: '/personal/imports/chatgpt/',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppChatAgentsIdChatChatIdIndexRoute =
  AppChatAgentsIdChatChatIdIndexRouteImport.update({
    id: '/chat/$chatId/',
    path: '/chat/$chatId/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatAgentsIdRunsRunIdIndexRoute =
  AppChatAgentsIdRunsRunIdIndexRouteImport.update({
    id: '/runs/$runId/',
    path: '/runs/$runId/',
    getParentRoute: () => AppChatAgentsIdRouteRoute,
  } as any)
const AppChatProjectsProjectIdChatChatIdIndexRoute =
  AppChatProjectsProjectIdChatChatIdIndexRouteImport.update({
    id: '/chat/$chatId/',
    path: '/chat/$chatId/',
    getParentRoute: () => AppChatProjectsProjectIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/public': typeof PublicRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/office/auth-callback': typeof OfficeAuthCallbackRoute
  '/office/taskpane': typeof OfficeTaskpaneRoute
  '/public/chat/$slug': typeof PublicChatSlugRoute
  '/public/share/$token': typeof PublicShareTokenRoute
  '/public/widget/$slug': typeof PublicWidgetSlugRoute
  '/forgot-password/': typeof AppForgotPasswordIndexRoute
  '/login/': typeof AppLoginIndexRoute
  '/reset-password/': typeof AppResetPasswordIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/signup/': typeof AppSignupIndexRoute
  '/agents/$id': typeof AppChatAgentsIdRouteRouteWithChildren
  '/apps/$id': typeof AppChatAppsIdRouteRouteWithChildren
  '/projects/$projectId': typeof AppChatProjectsProjectIdRouteRouteWithChildren
  '/skills/$id': typeof AppChatSkillsIdRouteRouteWithChildren
  '/chat/$id': typeof AppChatChatIdRoute
  '/chat/new': typeof AppChatChatNewRoute
  '/agents/': typeof AppChatAgentsIndexRoute
  '/apps/': typeof AppChatAppsIndexRoute
  '/chat/': typeof AppChatChatIndexRoute
  '/projects/': typeof AppChatProjectsIndexRoute
  '/skills/': typeof AppChatSkillsIndexRoute
  '/staging-inbox/': typeof AppChatStagingInboxIndexRoute
  '/email-change/confirm/': typeof AppEmailChangeConfirmIndexRoute
  '/invite/accept/': typeof AppInviteAcceptIndexRoute
  '/oauth/callback/': typeof AppOauthCallbackIndexRoute
  '/oauth/mcp-consent/': typeof AppOauthMcpConsentIndexRoute
  '/settings/analytics/': typeof AppSettingsAnalyticsIndexRoute
  '/settings/billing/': typeof AppSettingsBillingIndexRoute
  '/settings/connections/': typeof AppSettingsConnectionsIndexRoute
  '/settings/credentials/': typeof AppSettingsCredentialsIndexRoute
  '/settings/data-sources/': typeof AppSettingsDataSourcesIndexRoute
  '/settings/error-log/': typeof AppSettingsErrorLogIndexRoute
  '/settings/feature-flags/': typeof AppSettingsFeatureFlagsIndexRoute
  '/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/settings/knowledge/': typeof AppSettingsKnowledgeIndexRoute
  '/settings/models/': typeof AppSettingsModelsIndexRoute
  '/settings/on-premise/': typeof AppSettingsOnPremiseIndexRoute
  '/settings/partner/': typeof AppSettingsPartnerIndexRoute
  '/settings/personal/': typeof AppSettingsPersonalIndexRoute
  '/settings/security/': typeof AppSettingsSecurityIndexRoute
  '/settings/tools/': typeof AppSettingsToolsIndexRoute
  '/settings/training-records/': typeof AppSettingsTrainingRecordsIndexRoute
  '/settings/training/': typeof AppSettingsTrainingIndexRoute
  '/settings/users/': typeof AppSettingsUsersIndexRoute
  '/settings/workspace-error-log/': typeof AppSettingsWorkspaceErrorLogIndexRoute
  '/settings/workspace/': typeof AppSettingsWorkspaceIndexRoute
  '/settings/workspaces/': typeof AppSettingsWorkspacesIndexRoute
  '/signup/complete/': typeof AppSignupCompleteIndexRoute
  '/apps/$id/access': typeof AppChatAppsIdAccessRoute
  '/apps/$id/open': typeof AppChatAppsIdOpenRoute
  '/agents/$id/': typeof AppChatAgentsIdIndexRoute
  '/apps/$id/': typeof AppChatAppsIdIndexRoute
  '/projects/$projectId/': typeof AppChatProjectsProjectIdIndexRoute
  '/projects/new/': typeof AppChatProjectsNewIndexRoute
  '/skills/$id/': typeof AppChatSkillsIdIndexRoute
  '/skills/new/': typeof AppChatSkillsNewIndexRoute
  '/settings/billing/checkout/': typeof AppSettingsBillingCheckoutIndexRoute
  '/settings/data-sources/$id/': typeof AppSettingsDataSourcesIdIndexRoute
  '/settings/groups/$id/': typeof AppSettingsGroupsIdIndexRoute
  '/settings/knowledge/$id/': typeof AppSettingsKnowledgeIdIndexRoute
  '/settings/on-premise/$id/': typeof AppSettingsOnPremiseIdIndexRoute
  '/settings/tools/$id/': typeof AppSettingsToolsIdIndexRoute
  '/settings/tools/new/': typeof AppSettingsToolsNewIndexRoute
  '/settings/tools/templates/': typeof AppSettingsToolsTemplatesIndexRoute
  '/agents/$id/danger/': typeof AppChatAgentsIdDangerIndexRoute
  '/agents/$id/files/': typeof AppChatAgentsIdFilesIndexRoute
  '/agents/$id/general/': typeof AppChatAgentsIdGeneralIndexRoute
  '/agents/$id/history/': typeof AppChatAgentsIdHistoryIndexRoute
  '/agents/$id/integrations/': typeof AppChatAgentsIdIntegrationsIndexRoute
  '/agents/$id/models-and-costs/': typeof AppChatAgentsIdModelsAndCostsIndexRoute
  '/agents/$id/prompt/': typeof AppChatAgentsIdPromptIndexRoute
  '/agents/$id/sharing/': typeof AppChatAgentsIdSharingIndexRoute
  '/agents/$id/trigger/': typeof AppChatAgentsIdTriggerIndexRoute
  '/apps/$id/general/': typeof AppChatAppsIdGeneralIndexRoute
  '/apps/$id/tools/': typeof AppChatAppsIdToolsIndexRoute
  '/apps/$id/versions/': typeof AppChatAppsIdVersionsIndexRoute
  '/projects/$projectId/settings/': typeof AppChatProjectsProjectIdSettingsIndexRoute
  '/projects/new/$chatId/': typeof AppChatProjectsNewChatIdIndexRoute
  '/skills/$id/connections/': typeof AppChatSkillsIdConnectionsIndexRoute
  '/skills/$id/danger/': typeof AppChatSkillsIdDangerIndexRoute
  '/skills/$id/definition/': typeof AppChatSkillsIdDefinitionIndexRoute
  '/skills/$id/files/': typeof AppChatSkillsIdFilesIndexRoute
  '/skills/$id/general/': typeof AppChatSkillsIdGeneralIndexRoute
  '/skills/$id/sharing/': typeof AppChatSkillsIdSharingIndexRoute
  '/skills/edit/$chatId/': typeof AppChatSkillsEditChatIdIndexRoute
  '/skills/new/$chatId/': typeof AppChatSkillsNewChatIdIndexRoute
  '/settings/personal/imports/chatgpt/': typeof AppSettingsPersonalImportsChatgptIndexRoute
  '/agents/$id/chat/$chatId/': typeof AppChatAgentsIdChatChatIdIndexRoute
  '/agents/$id/runs/$runId/': typeof AppChatAgentsIdRunsRunIdIndexRoute
  '/projects/$projectId/chat/$chatId/': typeof AppChatProjectsProjectIdChatChatIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/public': typeof PublicRouteRouteWithChildren
  '/office/auth-callback': typeof OfficeAuthCallbackRoute
  '/office/taskpane': typeof OfficeTaskpaneRoute
  '/public/chat/$slug': typeof PublicChatSlugRoute
  '/public/share/$token': typeof PublicShareTokenRoute
  '/public/widget/$slug': typeof PublicWidgetSlugRoute
  '/forgot-password': typeof AppForgotPasswordIndexRoute
  '/login': typeof AppLoginIndexRoute
  '/reset-password': typeof AppResetPasswordIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/signup': typeof AppSignupIndexRoute
  '/chat/$id': typeof AppChatChatIdRoute
  '/chat/new': typeof AppChatChatNewRoute
  '/agents': typeof AppChatAgentsIndexRoute
  '/apps': typeof AppChatAppsIndexRoute
  '/chat': typeof AppChatChatIndexRoute
  '/projects': typeof AppChatProjectsIndexRoute
  '/skills': typeof AppChatSkillsIndexRoute
  '/staging-inbox': typeof AppChatStagingInboxIndexRoute
  '/email-change/confirm': typeof AppEmailChangeConfirmIndexRoute
  '/invite/accept': typeof AppInviteAcceptIndexRoute
  '/oauth/callback': typeof AppOauthCallbackIndexRoute
  '/oauth/mcp-consent': typeof AppOauthMcpConsentIndexRoute
  '/settings/analytics': typeof AppSettingsAnalyticsIndexRoute
  '/settings/billing': typeof AppSettingsBillingIndexRoute
  '/settings/connections': typeof AppSettingsConnectionsIndexRoute
  '/settings/credentials': typeof AppSettingsCredentialsIndexRoute
  '/settings/data-sources': typeof AppSettingsDataSourcesIndexRoute
  '/settings/error-log': typeof AppSettingsErrorLogIndexRoute
  '/settings/feature-flags': typeof AppSettingsFeatureFlagsIndexRoute
  '/settings/groups': typeof AppSettingsGroupsIndexRoute
  '/settings/knowledge': typeof AppSettingsKnowledgeIndexRoute
  '/settings/models': typeof AppSettingsModelsIndexRoute
  '/settings/on-premise': typeof AppSettingsOnPremiseIndexRoute
  '/settings/partner': typeof AppSettingsPartnerIndexRoute
  '/settings/personal': typeof AppSettingsPersonalIndexRoute
  '/settings/security': typeof AppSettingsSecurityIndexRoute
  '/settings/tools': typeof AppSettingsToolsIndexRoute
  '/settings/training-records': typeof AppSettingsTrainingRecordsIndexRoute
  '/settings/training': typeof AppSettingsTrainingIndexRoute
  '/settings/users': typeof AppSettingsUsersIndexRoute
  '/settings/workspace-error-log': typeof AppSettingsWorkspaceErrorLogIndexRoute
  '/settings/workspace': typeof AppSettingsWorkspaceIndexRoute
  '/settings/workspaces': typeof AppSettingsWorkspacesIndexRoute
  '/signup/complete': typeof AppSignupCompleteIndexRoute
  '/apps/$id/access': typeof AppChatAppsIdAccessRoute
  '/apps/$id/open': typeof AppChatAppsIdOpenRoute
  '/agents/$id': typeof AppChatAgentsIdIndexRoute
  '/apps/$id': typeof AppChatAppsIdIndexRoute
  '/projects/$projectId': typeof AppChatProjectsProjectIdIndexRoute
  '/projects/new': typeof AppChatProjectsNewIndexRoute
  '/skills/$id': typeof AppChatSkillsIdIndexRoute
  '/skills/new': typeof AppChatSkillsNewIndexRoute
  '/settings/billing/checkout': typeof AppSettingsBillingCheckoutIndexRoute
  '/settings/data-sources/$id': typeof AppSettingsDataSourcesIdIndexRoute
  '/settings/groups/$id': typeof AppSettingsGroupsIdIndexRoute
  '/settings/knowledge/$id': typeof AppSettingsKnowledgeIdIndexRoute
  '/settings/on-premise/$id': typeof AppSettingsOnPremiseIdIndexRoute
  '/settings/tools/$id': typeof AppSettingsToolsIdIndexRoute
  '/settings/tools/new': typeof AppSettingsToolsNewIndexRoute
  '/settings/tools/templates': typeof AppSettingsToolsTemplatesIndexRoute
  '/agents/$id/danger': typeof AppChatAgentsIdDangerIndexRoute
  '/agents/$id/files': typeof AppChatAgentsIdFilesIndexRoute
  '/agents/$id/general': typeof AppChatAgentsIdGeneralIndexRoute
  '/agents/$id/history': typeof AppChatAgentsIdHistoryIndexRoute
  '/agents/$id/integrations': typeof AppChatAgentsIdIntegrationsIndexRoute
  '/agents/$id/models-and-costs': typeof AppChatAgentsIdModelsAndCostsIndexRoute
  '/agents/$id/prompt': typeof AppChatAgentsIdPromptIndexRoute
  '/agents/$id/sharing': typeof AppChatAgentsIdSharingIndexRoute
  '/agents/$id/trigger': typeof AppChatAgentsIdTriggerIndexRoute
  '/apps/$id/general': typeof AppChatAppsIdGeneralIndexRoute
  '/apps/$id/tools': typeof AppChatAppsIdToolsIndexRoute
  '/apps/$id/versions': typeof AppChatAppsIdVersionsIndexRoute
  '/projects/$projectId/settings': typeof AppChatProjectsProjectIdSettingsIndexRoute
  '/projects/new/$chatId': typeof AppChatProjectsNewChatIdIndexRoute
  '/skills/$id/connections': typeof AppChatSkillsIdConnectionsIndexRoute
  '/skills/$id/danger': typeof AppChatSkillsIdDangerIndexRoute
  '/skills/$id/definition': typeof AppChatSkillsIdDefinitionIndexRoute
  '/skills/$id/files': typeof AppChatSkillsIdFilesIndexRoute
  '/skills/$id/general': typeof AppChatSkillsIdGeneralIndexRoute
  '/skills/$id/sharing': typeof AppChatSkillsIdSharingIndexRoute
  '/skills/edit/$chatId': typeof AppChatSkillsEditChatIdIndexRoute
  '/skills/new/$chatId': typeof AppChatSkillsNewChatIdIndexRoute
  '/settings/personal/imports/chatgpt': typeof AppSettingsPersonalImportsChatgptIndexRoute
  '/agents/$id/chat/$chatId': typeof AppChatAgentsIdChatChatIdIndexRoute
  '/agents/$id/runs/$runId': typeof AppChatAgentsIdRunsRunIdIndexRoute
  '/projects/$projectId/chat/$chatId': typeof AppChatProjectsProjectIdChatChatIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/public': typeof PublicRouteRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/_app/_chat': typeof AppChatRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/office/auth-callback': typeof OfficeAuthCallbackRoute
  '/office/taskpane': typeof OfficeTaskpaneRoute
  '/public/chat/$slug': typeof PublicChatSlugRoute
  '/public/share/$token': typeof PublicShareTokenRoute
  '/public/widget/$slug': typeof PublicWidgetSlugRoute
  '/_app/forgot-password/': typeof AppForgotPasswordIndexRoute
  '/_app/login/': typeof AppLoginIndexRoute
  '/_app/reset-password/': typeof AppResetPasswordIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/signup/': typeof AppSignupIndexRoute
  '/_app/_chat/agents/$id': typeof AppChatAgentsIdRouteRouteWithChildren
  '/_app/_chat/apps/$id': typeof AppChatAppsIdRouteRouteWithChildren
  '/_app/_chat/projects/$projectId': typeof AppChatProjectsProjectIdRouteRouteWithChildren
  '/_app/_chat/skills/$id': typeof AppChatSkillsIdRouteRouteWithChildren
  '/_app/_chat/chat/$id': typeof AppChatChatIdRoute
  '/_app/_chat/chat/new': typeof AppChatChatNewRoute
  '/_app/_chat/agents/': typeof AppChatAgentsIndexRoute
  '/_app/_chat/apps/': typeof AppChatAppsIndexRoute
  '/_app/_chat/chat/': typeof AppChatChatIndexRoute
  '/_app/_chat/projects/': typeof AppChatProjectsIndexRoute
  '/_app/_chat/skills/': typeof AppChatSkillsIndexRoute
  '/_app/_chat/staging-inbox/': typeof AppChatStagingInboxIndexRoute
  '/_app/email-change/confirm/': typeof AppEmailChangeConfirmIndexRoute
  '/_app/invite/accept/': typeof AppInviteAcceptIndexRoute
  '/_app/oauth/callback/': typeof AppOauthCallbackIndexRoute
  '/_app/oauth/mcp-consent/': typeof AppOauthMcpConsentIndexRoute
  '/_app/settings/analytics/': typeof AppSettingsAnalyticsIndexRoute
  '/_app/settings/billing/': typeof AppSettingsBillingIndexRoute
  '/_app/settings/connections/': typeof AppSettingsConnectionsIndexRoute
  '/_app/settings/credentials/': typeof AppSettingsCredentialsIndexRoute
  '/_app/settings/data-sources/': typeof AppSettingsDataSourcesIndexRoute
  '/_app/settings/error-log/': typeof AppSettingsErrorLogIndexRoute
  '/_app/settings/feature-flags/': typeof AppSettingsFeatureFlagsIndexRoute
  '/_app/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/_app/settings/knowledge/': typeof AppSettingsKnowledgeIndexRoute
  '/_app/settings/models/': typeof AppSettingsModelsIndexRoute
  '/_app/settings/on-premise/': typeof AppSettingsOnPremiseIndexRoute
  '/_app/settings/partner/': typeof AppSettingsPartnerIndexRoute
  '/_app/settings/personal/': typeof AppSettingsPersonalIndexRoute
  '/_app/settings/security/': typeof AppSettingsSecurityIndexRoute
  '/_app/settings/tools/': typeof AppSettingsToolsIndexRoute
  '/_app/settings/training-records/': typeof AppSettingsTrainingRecordsIndexRoute
  '/_app/settings/training/': typeof AppSettingsTrainingIndexRoute
  '/_app/settings/users/': typeof AppSettingsUsersIndexRoute
  '/_app/settings/workspace-error-log/': typeof AppSettingsWorkspaceErrorLogIndexRoute
  '/_app/settings/workspace/': typeof AppSettingsWorkspaceIndexRoute
  '/_app/settings/workspaces/': typeof AppSettingsWorkspacesIndexRoute
  '/_app/signup/complete/': typeof AppSignupCompleteIndexRoute
  '/_app/_chat/apps/$id/access': typeof AppChatAppsIdAccessRoute
  '/_app/_chat/apps/$id_/open': typeof AppChatAppsIdOpenRoute
  '/_app/_chat/agents/$id/': typeof AppChatAgentsIdIndexRoute
  '/_app/_chat/apps/$id/': typeof AppChatAppsIdIndexRoute
  '/_app/_chat/projects/$projectId/': typeof AppChatProjectsProjectIdIndexRoute
  '/_app/_chat/projects/new/': typeof AppChatProjectsNewIndexRoute
  '/_app/_chat/skills/$id/': typeof AppChatSkillsIdIndexRoute
  '/_app/_chat/skills/new/': typeof AppChatSkillsNewIndexRoute
  '/_app/settings/billing/checkout/': typeof AppSettingsBillingCheckoutIndexRoute
  '/_app/settings/data-sources/$id/': typeof AppSettingsDataSourcesIdIndexRoute
  '/_app/settings/groups/$id/': typeof AppSettingsGroupsIdIndexRoute
  '/_app/settings/knowledge/$id/': typeof AppSettingsKnowledgeIdIndexRoute
  '/_app/settings/on-premise/$id/': typeof AppSettingsOnPremiseIdIndexRoute
  '/_app/settings/tools/$id/': typeof AppSettingsToolsIdIndexRoute
  '/_app/settings/tools/new/': typeof AppSettingsToolsNewIndexRoute
  '/_app/settings/tools/templates/': typeof AppSettingsToolsTemplatesIndexRoute
  '/_app/_chat/agents/$id/danger/': typeof AppChatAgentsIdDangerIndexRoute
  '/_app/_chat/agents/$id/files/': typeof AppChatAgentsIdFilesIndexRoute
  '/_app/_chat/agents/$id/general/': typeof AppChatAgentsIdGeneralIndexRoute
  '/_app/_chat/agents/$id/history/': typeof AppChatAgentsIdHistoryIndexRoute
  '/_app/_chat/agents/$id/integrations/': typeof AppChatAgentsIdIntegrationsIndexRoute
  '/_app/_chat/agents/$id/models-and-costs/': typeof AppChatAgentsIdModelsAndCostsIndexRoute
  '/_app/_chat/agents/$id/prompt/': typeof AppChatAgentsIdPromptIndexRoute
  '/_app/_chat/agents/$id/sharing/': typeof AppChatAgentsIdSharingIndexRoute
  '/_app/_chat/agents/$id/trigger/': typeof AppChatAgentsIdTriggerIndexRoute
  '/_app/_chat/apps/$id/general/': typeof AppChatAppsIdGeneralIndexRoute
  '/_app/_chat/apps/$id/tools/': typeof AppChatAppsIdToolsIndexRoute
  '/_app/_chat/apps/$id/versions/': typeof AppChatAppsIdVersionsIndexRoute
  '/_app/_chat/projects/$projectId/settings/': typeof AppChatProjectsProjectIdSettingsIndexRoute
  '/_app/_chat/projects/new/$chatId/': typeof AppChatProjectsNewChatIdIndexRoute
  '/_app/_chat/skills/$id/connections/': typeof AppChatSkillsIdConnectionsIndexRoute
  '/_app/_chat/skills/$id/danger/': typeof AppChatSkillsIdDangerIndexRoute
  '/_app/_chat/skills/$id/definition/': typeof AppChatSkillsIdDefinitionIndexRoute
  '/_app/_chat/skills/$id/files/': typeof AppChatSkillsIdFilesIndexRoute
  '/_app/_chat/skills/$id/general/': typeof AppChatSkillsIdGeneralIndexRoute
  '/_app/_chat/skills/$id/sharing/': typeof AppChatSkillsIdSharingIndexRoute
  '/_app/_chat/skills/edit/$chatId/': typeof AppChatSkillsEditChatIdIndexRoute
  '/_app/_chat/skills/new/$chatId/': typeof AppChatSkillsNewChatIdIndexRoute
  '/_app/settings/personal/imports/chatgpt/': typeof AppSettingsPersonalImportsChatgptIndexRoute
  '/_app/_chat/agents/$id/chat/$chatId/': typeof AppChatAgentsIdChatChatIdIndexRoute
  '/_app/_chat/agents/$id/runs/$runId/': typeof AppChatAgentsIdRunsRunIdIndexRoute
  '/_app/_chat/projects/$projectId/chat/$chatId/': typeof AppChatProjectsProjectIdChatChatIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/public'
    | '/settings'
    | '/office/auth-callback'
    | '/office/taskpane'
    | '/public/chat/$slug'
    | '/public/share/$token'
    | '/public/widget/$slug'
    | '/forgot-password/'
    | '/login/'
    | '/reset-password/'
    | '/settings/'
    | '/signup/'
    | '/agents/$id'
    | '/apps/$id'
    | '/projects/$projectId'
    | '/skills/$id'
    | '/chat/$id'
    | '/chat/new'
    | '/agents/'
    | '/apps/'
    | '/chat/'
    | '/projects/'
    | '/skills/'
    | '/staging-inbox/'
    | '/email-change/confirm/'
    | '/invite/accept/'
    | '/oauth/callback/'
    | '/oauth/mcp-consent/'
    | '/settings/analytics/'
    | '/settings/billing/'
    | '/settings/connections/'
    | '/settings/credentials/'
    | '/settings/data-sources/'
    | '/settings/error-log/'
    | '/settings/feature-flags/'
    | '/settings/groups/'
    | '/settings/knowledge/'
    | '/settings/models/'
    | '/settings/on-premise/'
    | '/settings/partner/'
    | '/settings/personal/'
    | '/settings/security/'
    | '/settings/tools/'
    | '/settings/training-records/'
    | '/settings/training/'
    | '/settings/users/'
    | '/settings/workspace-error-log/'
    | '/settings/workspace/'
    | '/settings/workspaces/'
    | '/signup/complete/'
    | '/apps/$id/access'
    | '/apps/$id/open'
    | '/agents/$id/'
    | '/apps/$id/'
    | '/projects/$projectId/'
    | '/projects/new/'
    | '/skills/$id/'
    | '/skills/new/'
    | '/settings/billing/checkout/'
    | '/settings/data-sources/$id/'
    | '/settings/groups/$id/'
    | '/settings/knowledge/$id/'
    | '/settings/on-premise/$id/'
    | '/settings/tools/$id/'
    | '/settings/tools/new/'
    | '/settings/tools/templates/'
    | '/agents/$id/danger/'
    | '/agents/$id/files/'
    | '/agents/$id/general/'
    | '/agents/$id/history/'
    | '/agents/$id/integrations/'
    | '/agents/$id/models-and-costs/'
    | '/agents/$id/prompt/'
    | '/agents/$id/sharing/'
    | '/agents/$id/trigger/'
    | '/apps/$id/general/'
    | '/apps/$id/tools/'
    | '/apps/$id/versions/'
    | '/projects/$projectId/settings/'
    | '/projects/new/$chatId/'
    | '/skills/$id/connections/'
    | '/skills/$id/danger/'
    | '/skills/$id/definition/'
    | '/skills/$id/files/'
    | '/skills/$id/general/'
    | '/skills/$id/sharing/'
    | '/skills/edit/$chatId/'
    | '/skills/new/$chatId/'
    | '/settings/personal/imports/chatgpt/'
    | '/agents/$id/chat/$chatId/'
    | '/agents/$id/runs/$runId/'
    | '/projects/$projectId/chat/$chatId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/public'
    | '/office/auth-callback'
    | '/office/taskpane'
    | '/public/chat/$slug'
    | '/public/share/$token'
    | '/public/widget/$slug'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/settings'
    | '/signup'
    | '/chat/$id'
    | '/chat/new'
    | '/agents'
    | '/apps'
    | '/chat'
    | '/projects'
    | '/skills'
    | '/staging-inbox'
    | '/email-change/confirm'
    | '/invite/accept'
    | '/oauth/callback'
    | '/oauth/mcp-consent'
    | '/settings/analytics'
    | '/settings/billing'
    | '/settings/connections'
    | '/settings/credentials'
    | '/settings/data-sources'
    | '/settings/error-log'
    | '/settings/feature-flags'
    | '/settings/groups'
    | '/settings/knowledge'
    | '/settings/models'
    | '/settings/on-premise'
    | '/settings/partner'
    | '/settings/personal'
    | '/settings/security'
    | '/settings/tools'
    | '/settings/training-records'
    | '/settings/training'
    | '/settings/users'
    | '/settings/workspace-error-log'
    | '/settings/workspace'
    | '/settings/workspaces'
    | '/signup/complete'
    | '/apps/$id/access'
    | '/apps/$id/open'
    | '/agents/$id'
    | '/apps/$id'
    | '/projects/$projectId'
    | '/projects/new'
    | '/skills/$id'
    | '/skills/new'
    | '/settings/billing/checkout'
    | '/settings/data-sources/$id'
    | '/settings/groups/$id'
    | '/settings/knowledge/$id'
    | '/settings/on-premise/$id'
    | '/settings/tools/$id'
    | '/settings/tools/new'
    | '/settings/tools/templates'
    | '/agents/$id/danger'
    | '/agents/$id/files'
    | '/agents/$id/general'
    | '/agents/$id/history'
    | '/agents/$id/integrations'
    | '/agents/$id/models-and-costs'
    | '/agents/$id/prompt'
    | '/agents/$id/sharing'
    | '/agents/$id/trigger'
    | '/apps/$id/general'
    | '/apps/$id/tools'
    | '/apps/$id/versions'
    | '/projects/$projectId/settings'
    | '/projects/new/$chatId'
    | '/skills/$id/connections'
    | '/skills/$id/danger'
    | '/skills/$id/definition'
    | '/skills/$id/files'
    | '/skills/$id/general'
    | '/skills/$id/sharing'
    | '/skills/edit/$chatId'
    | '/skills/new/$chatId'
    | '/settings/personal/imports/chatgpt'
    | '/agents/$id/chat/$chatId'
    | '/agents/$id/runs/$runId'
    | '/projects/$projectId/chat/$chatId'
  id:
    | '__root__'
    | '/'
    | '/public'
    | '/_app'
    | '/_app/_chat'
    | '/_app/settings'
    | '/office/auth-callback'
    | '/office/taskpane'
    | '/public/chat/$slug'
    | '/public/share/$token'
    | '/public/widget/$slug'
    | '/_app/forgot-password/'
    | '/_app/login/'
    | '/_app/reset-password/'
    | '/_app/settings/'
    | '/_app/signup/'
    | '/_app/_chat/agents/$id'
    | '/_app/_chat/apps/$id'
    | '/_app/_chat/projects/$projectId'
    | '/_app/_chat/skills/$id'
    | '/_app/_chat/chat/$id'
    | '/_app/_chat/chat/new'
    | '/_app/_chat/agents/'
    | '/_app/_chat/apps/'
    | '/_app/_chat/chat/'
    | '/_app/_chat/projects/'
    | '/_app/_chat/skills/'
    | '/_app/_chat/staging-inbox/'
    | '/_app/email-change/confirm/'
    | '/_app/invite/accept/'
    | '/_app/oauth/callback/'
    | '/_app/oauth/mcp-consent/'
    | '/_app/settings/analytics/'
    | '/_app/settings/billing/'
    | '/_app/settings/connections/'
    | '/_app/settings/credentials/'
    | '/_app/settings/data-sources/'
    | '/_app/settings/error-log/'
    | '/_app/settings/feature-flags/'
    | '/_app/settings/groups/'
    | '/_app/settings/knowledge/'
    | '/_app/settings/models/'
    | '/_app/settings/on-premise/'
    | '/_app/settings/partner/'
    | '/_app/settings/personal/'
    | '/_app/settings/security/'
    | '/_app/settings/tools/'
    | '/_app/settings/training-records/'
    | '/_app/settings/training/'
    | '/_app/settings/users/'
    | '/_app/settings/workspace-error-log/'
    | '/_app/settings/workspace/'
    | '/_app/settings/workspaces/'
    | '/_app/signup/complete/'
    | '/_app/_chat/apps/$id/access'
    | '/_app/_chat/apps/$id_/open'
    | '/_app/_chat/agents/$id/'
    | '/_app/_chat/apps/$id/'
    | '/_app/_chat/projects/$projectId/'
    | '/_app/_chat/projects/new/'
    | '/_app/_chat/skills/$id/'
    | '/_app/_chat/skills/new/'
    | '/_app/settings/billing/checkout/'
    | '/_app/settings/data-sources/$id/'
    | '/_app/settings/groups/$id/'
    | '/_app/settings/knowledge/$id/'
    | '/_app/settings/on-premise/$id/'
    | '/_app/settings/tools/$id/'
    | '/_app/settings/tools/new/'
    | '/_app/settings/tools/templates/'
    | '/_app/_chat/agents/$id/danger/'
    | '/_app/_chat/agents/$id/files/'
    | '/_app/_chat/agents/$id/general/'
    | '/_app/_chat/agents/$id/history/'
    | '/_app/_chat/agents/$id/integrations/'
    | '/_app/_chat/agents/$id/models-and-costs/'
    | '/_app/_chat/agents/$id/prompt/'
    | '/_app/_chat/agents/$id/sharing/'
    | '/_app/_chat/agents/$id/trigger/'
    | '/_app/_chat/apps/$id/general/'
    | '/_app/_chat/apps/$id/tools/'
    | '/_app/_chat/apps/$id/versions/'
    | '/_app/_chat/projects/$projectId/settings/'
    | '/_app/_chat/projects/new/$chatId/'
    | '/_app/_chat/skills/$id/connections/'
    | '/_app/_chat/skills/$id/danger/'
    | '/_app/_chat/skills/$id/definition/'
    | '/_app/_chat/skills/$id/files/'
    | '/_app/_chat/skills/$id/general/'
    | '/_app/_chat/skills/$id/sharing/'
    | '/_app/_chat/skills/edit/$chatId/'
    | '/_app/_chat/skills/new/$chatId/'
    | '/_app/settings/personal/imports/chatgpt/'
    | '/_app/_chat/agents/$id/chat/$chatId/'
    | '/_app/_chat/agents/$id/runs/$runId/'
    | '/_app/_chat/projects/$projectId/chat/$chatId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  OfficeAuthCallbackRoute: typeof OfficeAuthCallbackRoute
  OfficeTaskpaneRoute: typeof OfficeTaskpaneRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public': {
      id: '/public'
      path: '/public'
      fullPath: '/public'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_chat': {
      id: '/_app/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppChatRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/office/auth-callback': {
      id: '/office/auth-callback'
      path: '/office/auth-callback'
      fullPath: '/office/auth-callback'
      preLoaderRoute: typeof OfficeAuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/office/taskpane': {
      id: '/office/taskpane'
      path: '/office/taskpane'
      fullPath: '/office/taskpane'
      preLoaderRoute: typeof OfficeTaskpaneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/forgot-password/': {
      id: '/_app/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof AppForgotPasswordIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/login/': {
      id: '/_app/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AppLoginIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reset-password/': {
      id: '/_app/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof AppResetPasswordIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/signup/': {
      id: '/_app/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof AppSignupIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/public/chat/$slug': {
      id: '/public/chat/$slug'
      path: '/chat/$slug'
      fullPath: '/public/chat/$slug'
      preLoaderRoute: typeof PublicChatSlugRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/public/share/$token': {
      id: '/public/share/$token'
      path: '/share/$token'
      fullPath: '/public/share/$token'
      preLoaderRoute: typeof PublicShareTokenRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/public/widget/$slug': {
      id: '/public/widget/$slug'
      path: '/widget/$slug'
      fullPath: '/public/widget/$slug'
      preLoaderRoute: typeof PublicWidgetSlugRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_app/_chat/agents/': {
      id: '/_app/_chat/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AppChatAgentsIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/agents/$id': {
      id: '/_app/_chat/agents/$id'
      path: '/agents/$id'
      fullPath: '/agents/$id'
      preLoaderRoute: typeof AppChatAgentsIdRouteRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/apps/': {
      id: '/_app/_chat/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AppChatAppsIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/apps/$id': {
      id: '/_app/_chat/apps/$id'
      path: '/apps/$id'
      fullPath: '/apps/$id'
      preLoaderRoute: typeof AppChatAppsIdRouteRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/chat/': {
      id: '/_app/_chat/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof AppChatChatIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/chat/$id': {
      id: '/_app/_chat/chat/$id'
      path: '/chat/$id'
      fullPath: '/chat/$id'
      preLoaderRoute: typeof AppChatChatIdRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/chat/new': {
      id: '/_app/_chat/chat/new'
      path: '/chat/new'
      fullPath: '/chat/new'
      preLoaderRoute: typeof AppChatChatNewRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/projects/': {
      id: '/_app/_chat/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppChatProjectsIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/projects/$projectId': {
      id: '/_app/_chat/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppChatProjectsProjectIdRouteRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/skills/': {
      id: '/_app/_chat/skills/'
      path: '/skills'
      fullPath: '/skills/'
      preLoaderRoute: typeof AppChatSkillsIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/skills/$id': {
      id: '/_app/_chat/skills/$id'
      path: '/skills/$id'
      fullPath: '/skills/$id'
      preLoaderRoute: typeof AppChatSkillsIdRouteRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/staging-inbox/': {
      id: '/_app/_chat/staging-inbox/'
      path: '/staging-inbox'
      fullPath: '/staging-inbox/'
      preLoaderRoute: typeof AppChatStagingInboxIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/email-change/confirm/': {
      id: '/_app/email-change/confirm/'
      path: '/email-change/confirm'
      fullPath: '/email-change/confirm/'
      preLoaderRoute: typeof AppEmailChangeConfirmIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invite/accept/': {
      id: '/_app/invite/accept/'
      path: '/invite/accept'
      fullPath: '/invite/accept/'
      preLoaderRoute: typeof AppInviteAcceptIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/oauth/callback/': {
      id: '/_app/oauth/callback/'
      path: '/oauth/callback'
      fullPath: '/oauth/callback/'
      preLoaderRoute: typeof AppOauthCallbackIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/oauth/mcp-consent/': {
      id: '/_app/oauth/mcp-consent/'
      path: '/oauth/mcp-consent'
      fullPath: '/oauth/mcp-consent/'
      preLoaderRoute: typeof AppOauthMcpConsentIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/analytics/': {
      id: '/_app/settings/analytics/'
      path: '/analytics'
      fullPath: '/settings/analytics/'
      preLoaderRoute: typeof AppSettingsAnalyticsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/billing/': {
      id: '/_app/settings/billing/'
      path: '/billing'
      fullPath: '/settings/billing/'
      preLoaderRoute: typeof AppSettingsBillingIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/connections/': {
      id: '/_app/settings/connections/'
      path: '/connections'
      fullPath: '/settings/connections/'
      preLoaderRoute: typeof AppSettingsConnectionsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/credentials/': {
      id: '/_app/settings/credentials/'
      path: '/credentials'
      fullPath: '/settings/credentials/'
      preLoaderRoute: typeof AppSettingsCredentialsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/data-sources/': {
      id: '/_app/settings/data-sources/'
      path: '/data-sources'
      fullPath: '/settings/data-sources/'
      preLoaderRoute: typeof AppSettingsDataSourcesIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/error-log/': {
      id: '/_app/settings/error-log/'
      path: '/error-log'
      fullPath: '/settings/error-log/'
      preLoaderRoute: typeof AppSettingsErrorLogIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/feature-flags/': {
      id: '/_app/settings/feature-flags/'
      path: '/feature-flags'
      fullPath: '/settings/feature-flags/'
      preLoaderRoute: typeof AppSettingsFeatureFlagsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/groups/': {
      id: '/_app/settings/groups/'
      path: '/groups'
      fullPath: '/settings/groups/'
      preLoaderRoute: typeof AppSettingsGroupsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/knowledge/': {
      id: '/_app/settings/knowledge/'
      path: '/knowledge'
      fullPath: '/settings/knowledge/'
      preLoaderRoute: typeof AppSettingsKnowledgeIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/models/': {
      id: '/_app/settings/models/'
      path: '/models'
      fullPath: '/settings/models/'
      preLoaderRoute: typeof AppSettingsModelsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/on-premise/': {
      id: '/_app/settings/on-premise/'
      path: '/on-premise'
      fullPath: '/settings/on-premise/'
      preLoaderRoute: typeof AppSettingsOnPremiseIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/partner/': {
      id: '/_app/settings/partner/'
      path: '/partner'
      fullPath: '/settings/partner/'
      preLoaderRoute: typeof AppSettingsPartnerIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/personal/': {
      id: '/_app/settings/personal/'
      path: '/personal'
      fullPath: '/settings/personal/'
      preLoaderRoute: typeof AppSettingsPersonalIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/security/': {
      id: '/_app/settings/security/'
      path: '/security'
      fullPath: '/settings/security/'
      preLoaderRoute: typeof AppSettingsSecurityIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tools/': {
      id: '/_app/settings/tools/'
      path: '/tools'
      fullPath: '/settings/tools/'
      preLoaderRoute: typeof AppSettingsToolsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/training-records/': {
      id: '/_app/settings/training-records/'
      path: '/training-records'
      fullPath: '/settings/training-records/'
      preLoaderRoute: typeof AppSettingsTrainingRecordsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/training/': {
      id: '/_app/settings/training/'
      path: '/training'
      fullPath: '/settings/training/'
      preLoaderRoute: typeof AppSettingsTrainingIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/users/': {
      id: '/_app/settings/users/'
      path: '/users'
      fullPath: '/settings/users/'
      preLoaderRoute: typeof AppSettingsUsersIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/workspace-error-log/': {
      id: '/_app/settings/workspace-error-log/'
      path: '/workspace-error-log'
      fullPath: '/settings/workspace-error-log/'
      preLoaderRoute: typeof AppSettingsWorkspaceErrorLogIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/workspace/': {
      id: '/_app/settings/workspace/'
      path: '/workspace'
      fullPath: '/settings/workspace/'
      preLoaderRoute: typeof AppSettingsWorkspaceIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/workspaces/': {
      id: '/_app/settings/workspaces/'
      path: '/workspaces'
      fullPath: '/settings/workspaces/'
      preLoaderRoute: typeof AppSettingsWorkspacesIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/signup/complete/': {
      id: '/_app/signup/complete/'
      path: '/signup/complete'
      fullPath: '/signup/complete/'
      preLoaderRoute: typeof AppSignupCompleteIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_chat/agents/$id/': {
      id: '/_app/_chat/agents/$id/'
      path: '/'
      fullPath: '/agents/$id/'
      preLoaderRoute: typeof AppChatAgentsIdIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/apps/$id/': {
      id: '/_app/_chat/apps/$id/'
      path: '/'
      fullPath: '/apps/$id/'
      preLoaderRoute: typeof AppChatAppsIdIndexRouteImport
      parentRoute: typeof AppChatAppsIdRouteRoute
    }
    '/_app/_chat/apps/$id/access': {
      id: '/_app/_chat/apps/$id/access'
      path: '/access'
      fullPath: '/apps/$id/access'
      preLoaderRoute: typeof AppChatAppsIdAccessRouteImport
      parentRoute: typeof AppChatAppsIdRouteRoute
    }
    '/_app/_chat/apps/$id_/open': {
      id: '/_app/_chat/apps/$id_/open'
      path: '/apps/$id/open'
      fullPath: '/apps/$id/open'
      preLoaderRoute: typeof AppChatAppsIdOpenRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/projects/$projectId/': {
      id: '/_app/_chat/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AppChatProjectsProjectIdIndexRouteImport
      parentRoute: typeof AppChatProjectsProjectIdRouteRoute
    }
    '/_app/_chat/projects/new/': {
      id: '/_app/_chat/projects/new/'
      path: '/projects/new'
      fullPath: '/projects/new/'
      preLoaderRoute: typeof AppChatProjectsNewIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/skills/$id/': {
      id: '/_app/_chat/skills/$id/'
      path: '/'
      fullPath: '/skills/$id/'
      preLoaderRoute: typeof AppChatSkillsIdIndexRouteImport
      parentRoute: typeof AppChatSkillsIdRouteRoute
    }
    '/_app/_chat/skills/new/': {
      id: '/_app/_chat/skills/new/'
      path: '/skills/new'
      fullPath: '/skills/new/'
      preLoaderRoute: typeof AppChatSkillsNewIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/settings/billing/checkout/': {
      id: '/_app/settings/billing/checkout/'
      path: '/billing/checkout'
      fullPath: '/settings/billing/checkout/'
      preLoaderRoute: typeof AppSettingsBillingCheckoutIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/data-sources/$id/': {
      id: '/_app/settings/data-sources/$id/'
      path: '/data-sources/$id'
      fullPath: '/settings/data-sources/$id/'
      preLoaderRoute: typeof AppSettingsDataSourcesIdIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/groups/$id/': {
      id: '/_app/settings/groups/$id/'
      path: '/groups/$id'
      fullPath: '/settings/groups/$id/'
      preLoaderRoute: typeof AppSettingsGroupsIdIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/knowledge/$id/': {
      id: '/_app/settings/knowledge/$id/'
      path: '/knowledge/$id'
      fullPath: '/settings/knowledge/$id/'
      preLoaderRoute: typeof AppSettingsKnowledgeIdIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/on-premise/$id/': {
      id: '/_app/settings/on-premise/$id/'
      path: '/on-premise/$id'
      fullPath: '/settings/on-premise/$id/'
      preLoaderRoute: typeof AppSettingsOnPremiseIdIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tools/$id/': {
      id: '/_app/settings/tools/$id/'
      path: '/tools/$id'
      fullPath: '/settings/tools/$id/'
      preLoaderRoute: typeof AppSettingsToolsIdIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tools/new/': {
      id: '/_app/settings/tools/new/'
      path: '/tools/new'
      fullPath: '/settings/tools/new/'
      preLoaderRoute: typeof AppSettingsToolsNewIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tools/templates/': {
      id: '/_app/settings/tools/templates/'
      path: '/tools/templates'
      fullPath: '/settings/tools/templates/'
      preLoaderRoute: typeof AppSettingsToolsTemplatesIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/_chat/agents/$id/danger/': {
      id: '/_app/_chat/agents/$id/danger/'
      path: '/danger'
      fullPath: '/agents/$id/danger/'
      preLoaderRoute: typeof AppChatAgentsIdDangerIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/agents/$id/files/': {
      id: '/_app/_chat/agents/$id/files/'
      path: '/files'
      fullPath: '/agents/$id/files/'
      preLoaderRoute: typeof AppChatAgentsIdFilesIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/agents/$id/general/': {
      id: '/_app/_chat/agents/$id/general/'
      path: '/general'
      fullPath: '/agents/$id/general/'
      preLoaderRoute: typeof AppChatAgentsIdGeneralIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/agents/$id/history/': {
      id: '/_app/_chat/agents/$id/history/'
      path: '/history'
      fullPath: '/agents/$id/history/'
      preLoaderRoute: typeof AppChatAgentsIdHistoryIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/agents/$id/integrations/': {
      id: '/_app/_chat/agents/$id/integrations/'
      path: '/integrations'
      fullPath: '/agents/$id/integrations/'
      preLoaderRoute: typeof AppChatAgentsIdIntegrationsIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/agents/$id/models-and-costs/': {
      id: '/_app/_chat/agents/$id/models-and-costs/'
      path: '/models-and-costs'
      fullPath: '/agents/$id/models-and-costs/'
      preLoaderRoute: typeof AppChatAgentsIdModelsAndCostsIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/agents/$id/prompt/': {
      id: '/_app/_chat/agents/$id/prompt/'
      path: '/prompt'
      fullPath: '/agents/$id/prompt/'
      preLoaderRoute: typeof AppChatAgentsIdPromptIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/agents/$id/sharing/': {
      id: '/_app/_chat/agents/$id/sharing/'
      path: '/sharing'
      fullPath: '/agents/$id/sharing/'
      preLoaderRoute: typeof AppChatAgentsIdSharingIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/agents/$id/trigger/': {
      id: '/_app/_chat/agents/$id/trigger/'
      path: '/trigger'
      fullPath: '/agents/$id/trigger/'
      preLoaderRoute: typeof AppChatAgentsIdTriggerIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/apps/$id/general/': {
      id: '/_app/_chat/apps/$id/general/'
      path: '/general'
      fullPath: '/apps/$id/general/'
      preLoaderRoute: typeof AppChatAppsIdGeneralIndexRouteImport
      parentRoute: typeof AppChatAppsIdRouteRoute
    }
    '/_app/_chat/apps/$id/tools/': {
      id: '/_app/_chat/apps/$id/tools/'
      path: '/tools'
      fullPath: '/apps/$id/tools/'
      preLoaderRoute: typeof AppChatAppsIdToolsIndexRouteImport
      parentRoute: typeof AppChatAppsIdRouteRoute
    }
    '/_app/_chat/apps/$id/versions/': {
      id: '/_app/_chat/apps/$id/versions/'
      path: '/versions'
      fullPath: '/apps/$id/versions/'
      preLoaderRoute: typeof AppChatAppsIdVersionsIndexRouteImport
      parentRoute: typeof AppChatAppsIdRouteRoute
    }
    '/_app/_chat/projects/$projectId/settings/': {
      id: '/_app/_chat/projects/$projectId/settings/'
      path: '/settings'
      fullPath: '/projects/$projectId/settings/'
      preLoaderRoute: typeof AppChatProjectsProjectIdSettingsIndexRouteImport
      parentRoute: typeof AppChatProjectsProjectIdRouteRoute
    }
    '/_app/_chat/projects/new/$chatId/': {
      id: '/_app/_chat/projects/new/$chatId/'
      path: '/projects/new/$chatId'
      fullPath: '/projects/new/$chatId/'
      preLoaderRoute: typeof AppChatProjectsNewChatIdIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/skills/$id/connections/': {
      id: '/_app/_chat/skills/$id/connections/'
      path: '/connections'
      fullPath: '/skills/$id/connections/'
      preLoaderRoute: typeof AppChatSkillsIdConnectionsIndexRouteImport
      parentRoute: typeof AppChatSkillsIdRouteRoute
    }
    '/_app/_chat/skills/$id/danger/': {
      id: '/_app/_chat/skills/$id/danger/'
      path: '/danger'
      fullPath: '/skills/$id/danger/'
      preLoaderRoute: typeof AppChatSkillsIdDangerIndexRouteImport
      parentRoute: typeof AppChatSkillsIdRouteRoute
    }
    '/_app/_chat/skills/$id/definition/': {
      id: '/_app/_chat/skills/$id/definition/'
      path: '/definition'
      fullPath: '/skills/$id/definition/'
      preLoaderRoute: typeof AppChatSkillsIdDefinitionIndexRouteImport
      parentRoute: typeof AppChatSkillsIdRouteRoute
    }
    '/_app/_chat/skills/$id/files/': {
      id: '/_app/_chat/skills/$id/files/'
      path: '/files'
      fullPath: '/skills/$id/files/'
      preLoaderRoute: typeof AppChatSkillsIdFilesIndexRouteImport
      parentRoute: typeof AppChatSkillsIdRouteRoute
    }
    '/_app/_chat/skills/$id/general/': {
      id: '/_app/_chat/skills/$id/general/'
      path: '/general'
      fullPath: '/skills/$id/general/'
      preLoaderRoute: typeof AppChatSkillsIdGeneralIndexRouteImport
      parentRoute: typeof AppChatSkillsIdRouteRoute
    }
    '/_app/_chat/skills/$id/sharing/': {
      id: '/_app/_chat/skills/$id/sharing/'
      path: '/sharing'
      fullPath: '/skills/$id/sharing/'
      preLoaderRoute: typeof AppChatSkillsIdSharingIndexRouteImport
      parentRoute: typeof AppChatSkillsIdRouteRoute
    }
    '/_app/_chat/skills/edit/$chatId/': {
      id: '/_app/_chat/skills/edit/$chatId/'
      path: '/skills/edit/$chatId'
      fullPath: '/skills/edit/$chatId/'
      preLoaderRoute: typeof AppChatSkillsEditChatIdIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/_chat/skills/new/$chatId/': {
      id: '/_app/_chat/skills/new/$chatId/'
      path: '/skills/new/$chatId'
      fullPath: '/skills/new/$chatId/'
      preLoaderRoute: typeof AppChatSkillsNewChatIdIndexRouteImport
      parentRoute: typeof AppChatRouteRoute
    }
    '/_app/settings/personal/imports/chatgpt/': {
      id: '/_app/settings/personal/imports/chatgpt/'
      path: '/personal/imports/chatgpt'
      fullPath: '/settings/personal/imports/chatgpt/'
      preLoaderRoute: typeof AppSettingsPersonalImportsChatgptIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/_chat/agents/$id/chat/$chatId/': {
      id: '/_app/_chat/agents/$id/chat/$chatId/'
      path: '/chat/$chatId'
      fullPath: '/agents/$id/chat/$chatId/'
      preLoaderRoute: typeof AppChatAgentsIdChatChatIdIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/agents/$id/runs/$runId/': {
      id: '/_app/_chat/agents/$id/runs/$runId/'
      path: '/runs/$runId'
      fullPath: '/agents/$id/runs/$runId/'
      preLoaderRoute: typeof AppChatAgentsIdRunsRunIdIndexRouteImport
      parentRoute: typeof AppChatAgentsIdRouteRoute
    }
    '/_app/_chat/projects/$projectId/chat/$chatId/': {
      id: '/_app/_chat/projects/$projectId/chat/$chatId/'
      path: '/chat/$chatId'
      fullPath: '/projects/$projectId/chat/$chatId/'
      preLoaderRoute: typeof AppChatProjectsProjectIdChatChatIdIndexRouteImport
      parentRoute: typeof AppChatProjectsProjectIdRouteRoute
    }
  }
}

interface PublicRouteRouteChildren {
  PublicChatSlugRoute: typeof PublicChatSlugRoute
  PublicShareTokenRoute: typeof PublicShareTokenRoute
  PublicWidgetSlugRoute: typeof PublicWidgetSlugRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicChatSlugRoute: PublicChatSlugRoute,
  PublicShareTokenRoute: PublicShareTokenRoute,
  PublicWidgetSlugRoute: PublicWidgetSlugRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

interface AppChatAgentsIdRouteRouteChildren {
  AppChatAgentsIdIndexRoute: typeof AppChatAgentsIdIndexRoute
  AppChatAgentsIdDangerIndexRoute: typeof AppChatAgentsIdDangerIndexRoute
  AppChatAgentsIdFilesIndexRoute: typeof AppChatAgentsIdFilesIndexRoute
  AppChatAgentsIdGeneralIndexRoute: typeof AppChatAgentsIdGeneralIndexRoute
  AppChatAgentsIdHistoryIndexRoute: typeof AppChatAgentsIdHistoryIndexRoute
  AppChatAgentsIdIntegrationsIndexRoute: typeof AppChatAgentsIdIntegrationsIndexRoute
  AppChatAgentsIdModelsAndCostsIndexRoute: typeof AppChatAgentsIdModelsAndCostsIndexRoute
  AppChatAgentsIdPromptIndexRoute: typeof AppChatAgentsIdPromptIndexRoute
  AppChatAgentsIdSharingIndexRoute: typeof AppChatAgentsIdSharingIndexRoute
  AppChatAgentsIdTriggerIndexRoute: typeof AppChatAgentsIdTriggerIndexRoute
  AppChatAgentsIdChatChatIdIndexRoute: typeof AppChatAgentsIdChatChatIdIndexRoute
  AppChatAgentsIdRunsRunIdIndexRoute: typeof AppChatAgentsIdRunsRunIdIndexRoute
}

const AppChatAgentsIdRouteRouteChildren: AppChatAgentsIdRouteRouteChildren = {
  AppChatAgentsIdIndexRoute: AppChatAgentsIdIndexRoute,
  AppChatAgentsIdDangerIndexRoute: AppChatAgentsIdDangerIndexRoute,
  AppChatAgentsIdFilesIndexRoute: AppChatAgentsIdFilesIndexRoute,
  AppChatAgentsIdGeneralIndexRoute: AppChatAgentsIdGeneralIndexRoute,
  AppChatAgentsIdHistoryIndexRoute: AppChatAgentsIdHistoryIndexRoute,
  AppChatAgentsIdIntegrationsIndexRoute: AppChatAgentsIdIntegrationsIndexRoute,
  AppChatAgentsIdModelsAndCostsIndexRoute:
    AppChatAgentsIdModelsAndCostsIndexRoute,
  AppChatAgentsIdPromptIndexRoute: AppChatAgentsIdPromptIndexRoute,
  AppChatAgentsIdSharingIndexRoute: AppChatAgentsIdSharingIndexRoute,
  AppChatAgentsIdTriggerIndexRoute: AppChatAgentsIdTriggerIndexRoute,
  AppChatAgentsIdChatChatIdIndexRoute: AppChatAgentsIdChatChatIdIndexRoute,
  AppChatAgentsIdRunsRunIdIndexRoute: AppChatAgentsIdRunsRunIdIndexRoute,
}

const AppChatAgentsIdRouteRouteWithChildren =
  AppChatAgentsIdRouteRoute._addFileChildren(AppChatAgentsIdRouteRouteChildren)

interface AppChatAppsIdRouteRouteChildren {
  AppChatAppsIdAccessRoute: typeof AppChatAppsIdAccessRoute
  AppChatAppsIdIndexRoute: typeof AppChatAppsIdIndexRoute
  AppChatAppsIdGeneralIndexRoute: typeof AppChatAppsIdGeneralIndexRoute
  AppChatAppsIdToolsIndexRoute: typeof AppChatAppsIdToolsIndexRoute
  AppChatAppsIdVersionsIndexRoute: typeof AppChatAppsIdVersionsIndexRoute
}

const AppChatAppsIdRouteRouteChildren: AppChatAppsIdRouteRouteChildren = {
  AppChatAppsIdAccessRoute: AppChatAppsIdAccessRoute,
  AppChatAppsIdIndexRoute: AppChatAppsIdIndexRoute,
  AppChatAppsIdGeneralIndexRoute: AppChatAppsIdGeneralIndexRoute,
  AppChatAppsIdToolsIndexRoute: AppChatAppsIdToolsIndexRoute,
  AppChatAppsIdVersionsIndexRoute: AppChatAppsIdVersionsIndexRoute,
}

const AppChatAppsIdRouteRouteWithChildren =
  AppChatAppsIdRouteRoute._addFileChildren(AppChatAppsIdRouteRouteChildren)

interface AppChatProjectsProjectIdRouteRouteChildren {
  AppChatProjectsProjectIdIndexRoute: typeof AppChatProjectsProjectIdIndexRoute
  AppChatProjectsProjectIdSettingsIndexRoute: typeof AppChatProjectsProjectIdSettingsIndexRoute
  AppChatProjectsProjectIdChatChatIdIndexRoute: typeof AppChatProjectsProjectIdChatChatIdIndexRoute
}

const AppChatProjectsProjectIdRouteRouteChildren: AppChatProjectsProjectIdRouteRouteChildren =
  {
    AppChatProjectsProjectIdIndexRoute: AppChatProjectsProjectIdIndexRoute,
    AppChatProjectsProjectIdSettingsIndexRoute:
      AppChatProjectsProjectIdSettingsIndexRoute,
    AppChatProjectsProjectIdChatChatIdIndexRoute:
      AppChatProjectsProjectIdChatChatIdIndexRoute,
  }

const AppChatProjectsProjectIdRouteRouteWithChildren =
  AppChatProjectsProjectIdRouteRoute._addFileChildren(
    AppChatProjectsProjectIdRouteRouteChildren,
  )

interface AppChatSkillsIdRouteRouteChildren {
  AppChatSkillsIdIndexRoute: typeof AppChatSkillsIdIndexRoute
  AppChatSkillsIdConnectionsIndexRoute: typeof AppChatSkillsIdConnectionsIndexRoute
  AppChatSkillsIdDangerIndexRoute: typeof AppChatSkillsIdDangerIndexRoute
  AppChatSkillsIdDefinitionIndexRoute: typeof AppChatSkillsIdDefinitionIndexRoute
  AppChatSkillsIdFilesIndexRoute: typeof AppChatSkillsIdFilesIndexRoute
  AppChatSkillsIdGeneralIndexRoute: typeof AppChatSkillsIdGeneralIndexRoute
  AppChatSkillsIdSharingIndexRoute: typeof AppChatSkillsIdSharingIndexRoute
}

const AppChatSkillsIdRouteRouteChildren: AppChatSkillsIdRouteRouteChildren = {
  AppChatSkillsIdIndexRoute: AppChatSkillsIdIndexRoute,
  AppChatSkillsIdConnectionsIndexRoute: AppChatSkillsIdConnectionsIndexRoute,
  AppChatSkillsIdDangerIndexRoute: AppChatSkillsIdDangerIndexRoute,
  AppChatSkillsIdDefinitionIndexRoute: AppChatSkillsIdDefinitionIndexRoute,
  AppChatSkillsIdFilesIndexRoute: AppChatSkillsIdFilesIndexRoute,
  AppChatSkillsIdGeneralIndexRoute: AppChatSkillsIdGeneralIndexRoute,
  AppChatSkillsIdSharingIndexRoute: AppChatSkillsIdSharingIndexRoute,
}

const AppChatSkillsIdRouteRouteWithChildren =
  AppChatSkillsIdRouteRoute._addFileChildren(AppChatSkillsIdRouteRouteChildren)

interface AppChatRouteRouteChildren {
  AppChatAgentsIdRouteRoute: typeof AppChatAgentsIdRouteRouteWithChildren
  AppChatAppsIdRouteRoute: typeof AppChatAppsIdRouteRouteWithChildren
  AppChatProjectsProjectIdRouteRoute: typeof AppChatProjectsProjectIdRouteRouteWithChildren
  AppChatSkillsIdRouteRoute: typeof AppChatSkillsIdRouteRouteWithChildren
  AppChatChatIdRoute: typeof AppChatChatIdRoute
  AppChatChatNewRoute: typeof AppChatChatNewRoute
  AppChatAgentsIndexRoute: typeof AppChatAgentsIndexRoute
  AppChatAppsIndexRoute: typeof AppChatAppsIndexRoute
  AppChatChatIndexRoute: typeof AppChatChatIndexRoute
  AppChatProjectsIndexRoute: typeof AppChatProjectsIndexRoute
  AppChatSkillsIndexRoute: typeof AppChatSkillsIndexRoute
  AppChatStagingInboxIndexRoute: typeof AppChatStagingInboxIndexRoute
  AppChatAppsIdOpenRoute: typeof AppChatAppsIdOpenRoute
  AppChatProjectsNewIndexRoute: typeof AppChatProjectsNewIndexRoute
  AppChatSkillsNewIndexRoute: typeof AppChatSkillsNewIndexRoute
  AppChatProjectsNewChatIdIndexRoute: typeof AppChatProjectsNewChatIdIndexRoute
  AppChatSkillsEditChatIdIndexRoute: typeof AppChatSkillsEditChatIdIndexRoute
  AppChatSkillsNewChatIdIndexRoute: typeof AppChatSkillsNewChatIdIndexRoute
}

const AppChatRouteRouteChildren: AppChatRouteRouteChildren = {
  AppChatAgentsIdRouteRoute: AppChatAgentsIdRouteRouteWithChildren,
  AppChatAppsIdRouteRoute: AppChatAppsIdRouteRouteWithChildren,
  AppChatProjectsProjectIdRouteRoute:
    AppChatProjectsProjectIdRouteRouteWithChildren,
  AppChatSkillsIdRouteRoute: AppChatSkillsIdRouteRouteWithChildren,
  AppChatChatIdRoute: AppChatChatIdRoute,
  AppChatChatNewRoute: AppChatChatNewRoute,
  AppChatAgentsIndexRoute: AppChatAgentsIndexRoute,
  AppChatAppsIndexRoute: AppChatAppsIndexRoute,
  AppChatChatIndexRoute: AppChatChatIndexRoute,
  AppChatProjectsIndexRoute: AppChatProjectsIndexRoute,
  AppChatSkillsIndexRoute: AppChatSkillsIndexRoute,
  AppChatStagingInboxIndexRoute: AppChatStagingInboxIndexRoute,
  AppChatAppsIdOpenRoute: AppChatAppsIdOpenRoute,
  AppChatProjectsNewIndexRoute: AppChatProjectsNewIndexRoute,
  AppChatSkillsNewIndexRoute: AppChatSkillsNewIndexRoute,
  AppChatProjectsNewChatIdIndexRoute: AppChatProjectsNewChatIdIndexRoute,
  AppChatSkillsEditChatIdIndexRoute: AppChatSkillsEditChatIdIndexRoute,
  AppChatSkillsNewChatIdIndexRoute: AppChatSkillsNewChatIdIndexRoute,
}

const AppChatRouteRouteWithChildren = AppChatRouteRoute._addFileChildren(
  AppChatRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsAnalyticsIndexRoute: typeof AppSettingsAnalyticsIndexRoute
  AppSettingsBillingIndexRoute: typeof AppSettingsBillingIndexRoute
  AppSettingsConnectionsIndexRoute: typeof AppSettingsConnectionsIndexRoute
  AppSettingsCredentialsIndexRoute: typeof AppSettingsCredentialsIndexRoute
  AppSettingsDataSourcesIndexRoute: typeof AppSettingsDataSourcesIndexRoute
  AppSettingsErrorLogIndexRoute: typeof AppSettingsErrorLogIndexRoute
  AppSettingsFeatureFlagsIndexRoute: typeof AppSettingsFeatureFlagsIndexRoute
  AppSettingsGroupsIndexRoute: typeof AppSettingsGroupsIndexRoute
  AppSettingsKnowledgeIndexRoute: typeof AppSettingsKnowledgeIndexRoute
  AppSettingsModelsIndexRoute: typeof AppSettingsModelsIndexRoute
  AppSettingsOnPremiseIndexRoute: typeof AppSettingsOnPremiseIndexRoute
  AppSettingsPartnerIndexRoute: typeof AppSettingsPartnerIndexRoute
  AppSettingsPersonalIndexRoute: typeof AppSettingsPersonalIndexRoute
  AppSettingsSecurityIndexRoute: typeof AppSettingsSecurityIndexRoute
  AppSettingsToolsIndexRoute: typeof AppSettingsToolsIndexRoute
  AppSettingsTrainingRecordsIndexRoute: typeof AppSettingsTrainingRecordsIndexRoute
  AppSettingsTrainingIndexRoute: typeof AppSettingsTrainingIndexRoute
  AppSettingsUsersIndexRoute: typeof AppSettingsUsersIndexRoute
  AppSettingsWorkspaceErrorLogIndexRoute: typeof AppSettingsWorkspaceErrorLogIndexRoute
  AppSettingsWorkspaceIndexRoute: typeof AppSettingsWorkspaceIndexRoute
  AppSettingsWorkspacesIndexRoute: typeof AppSettingsWorkspacesIndexRoute
  AppSettingsBillingCheckoutIndexRoute: typeof AppSettingsBillingCheckoutIndexRoute
  AppSettingsDataSourcesIdIndexRoute: typeof AppSettingsDataSourcesIdIndexRoute
  AppSettingsGroupsIdIndexRoute: typeof AppSettingsGroupsIdIndexRoute
  AppSettingsKnowledgeIdIndexRoute: typeof AppSettingsKnowledgeIdIndexRoute
  AppSettingsOnPremiseIdIndexRoute: typeof AppSettingsOnPremiseIdIndexRoute
  AppSettingsToolsIdIndexRoute: typeof AppSettingsToolsIdIndexRoute
  AppSettingsToolsNewIndexRoute: typeof AppSettingsToolsNewIndexRoute
  AppSettingsToolsTemplatesIndexRoute: typeof AppSettingsToolsTemplatesIndexRoute
  AppSettingsPersonalImportsChatgptIndexRoute: typeof AppSettingsPersonalImportsChatgptIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsAnalyticsIndexRoute: AppSettingsAnalyticsIndexRoute,
  AppSettingsBillingIndexRoute: AppSettingsBillingIndexRoute,
  AppSettingsConnectionsIndexRoute: AppSettingsConnectionsIndexRoute,
  AppSettingsCredentialsIndexRoute: AppSettingsCredentialsIndexRoute,
  AppSettingsDataSourcesIndexRoute: AppSettingsDataSourcesIndexRoute,
  AppSettingsErrorLogIndexRoute: AppSettingsErrorLogIndexRoute,
  AppSettingsFeatureFlagsIndexRoute: AppSettingsFeatureFlagsIndexRoute,
  AppSettingsGroupsIndexRoute: AppSettingsGroupsIndexRoute,
  AppSettingsKnowledgeIndexRoute: AppSettingsKnowledgeIndexRoute,
  AppSettingsModelsIndexRoute: AppSettingsModelsIndexRoute,
  AppSettingsOnPremiseIndexRoute: AppSettingsOnPremiseIndexRoute,
  AppSettingsPartnerIndexRoute: AppSettingsPartnerIndexRoute,
  AppSettingsPersonalIndexRoute: AppSettingsPersonalIndexRoute,
  AppSettingsSecurityIndexRoute: AppSettingsSecurityIndexRoute,
  AppSettingsToolsIndexRoute: AppSettingsToolsIndexRoute,
  AppSettingsTrainingRecordsIndexRoute: AppSettingsTrainingRecordsIndexRoute,
  AppSettingsTrainingIndexRoute: AppSettingsTrainingIndexRoute,
  AppSettingsUsersIndexRoute: AppSettingsUsersIndexRoute,
  AppSettingsWorkspaceErrorLogIndexRoute:
    AppSettingsWorkspaceErrorLogIndexRoute,
  AppSettingsWorkspaceIndexRoute: AppSettingsWorkspaceIndexRoute,
  AppSettingsWorkspacesIndexRoute: AppSettingsWorkspacesIndexRoute,
  AppSettingsBillingCheckoutIndexRoute: AppSettingsBillingCheckoutIndexRoute,
  AppSettingsDataSourcesIdIndexRoute: AppSettingsDataSourcesIdIndexRoute,
  AppSettingsGroupsIdIndexRoute: AppSettingsGroupsIdIndexRoute,
  AppSettingsKnowledgeIdIndexRoute: AppSettingsKnowledgeIdIndexRoute,
  AppSettingsOnPremiseIdIndexRoute: AppSettingsOnPremiseIdIndexRoute,
  AppSettingsToolsIdIndexRoute: AppSettingsToolsIdIndexRoute,
  AppSettingsToolsNewIndexRoute: AppSettingsToolsNewIndexRoute,
  AppSettingsToolsTemplatesIndexRoute: AppSettingsToolsTemplatesIndexRoute,
  AppSettingsPersonalImportsChatgptIndexRoute:
    AppSettingsPersonalImportsChatgptIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteChildren {
  AppChatRouteRoute: typeof AppChatRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppForgotPasswordIndexRoute: typeof AppForgotPasswordIndexRoute
  AppLoginIndexRoute: typeof AppLoginIndexRoute
  AppResetPasswordIndexRoute: typeof AppResetPasswordIndexRoute
  AppSignupIndexRoute: typeof AppSignupIndexRoute
  AppEmailChangeConfirmIndexRoute: typeof AppEmailChangeConfirmIndexRoute
  AppInviteAcceptIndexRoute: typeof AppInviteAcceptIndexRoute
  AppOauthCallbackIndexRoute: typeof AppOauthCallbackIndexRoute
  AppOauthMcpConsentIndexRoute: typeof AppOauthMcpConsentIndexRoute
  AppSignupCompleteIndexRoute: typeof AppSignupCompleteIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppChatRouteRoute: AppChatRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppForgotPasswordIndexRoute: AppForgotPasswordIndexRoute,
  AppLoginIndexRoute: AppLoginIndexRoute,
  AppResetPasswordIndexRoute: AppResetPasswordIndexRoute,
  AppSignupIndexRoute: AppSignupIndexRoute,
  AppEmailChangeConfirmIndexRoute: AppEmailChangeConfirmIndexRoute,
  AppInviteAcceptIndexRoute: AppInviteAcceptIndexRoute,
  AppOauthCallbackIndexRoute: AppOauthCallbackIndexRoute,
  AppOauthMcpConsentIndexRoute: AppOauthMcpConsentIndexRoute,
  AppSignupCompleteIndexRoute: AppSignupCompleteIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  OfficeAuthCallbackRoute: OfficeAuthCallbackRoute,
  OfficeTaskpaneRoute: OfficeTaskpaneRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
